<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">{{ 'COUNTRIES.COUNTRY_SEO_FORM.EDIT' | translate }} - {{ city?.name }}</h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body p-0 d-flex flex-column">
  <form
    id="hotel-seo-form"
    (ngSubmit)="save()"
    [formGroup]="form"
    novalidate
    class="d-flex overflow-hidden flex-grow-1"
  >
    <ng-scrollbar class="locales-menu ps">
      <div class="modal-section-title mt-2 mb-2 ps-2">
        {{ 'CITIES.CITY_SEO_FORM.WEBSITES_LIST_TITLE' | translate }}
      </div>

      <div
        *ngFor="let websiteLocale of companyWebsiteLocales"
        (click)="selectCompanyWebSiteLocale(websiteLocale.id)"
        class="website-locale d-flex"
        [ngClass]="{ active: currentWebsiteLocaleId === websiteLocale.id }"
      >
        <div class="ico">
          <i class="fal fa-chevron-right"></i>
        </div>
        <div class="name">{{ websiteLocale.website.name }} - {{ websiteLocale.website.url }}</div>
        <div class="flag">
          <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
        </div>
      </div>
    </ng-scrollbar>

    <div class="flex-grow-1 overflow-auto">
      <div class="locales-content-wrapper" formArrayName="websiteLocales">
        <div *ngIf="!currentWebsiteLocaleId" class="modal-section-title ps-3 mt-2">
          {{ 'CITIES.CITY_SEO_FORM.SELECT_WEBSITE_MSG' | translate }}
        </div>

        <div *ngFor="let websiteLocale of form.get('websiteLocales')?.controls; let i = index" class="locales-content">
          <div
            [formGroupName]="i"
            *ngIf="currentWebsiteLocaleId === websiteLocale.get('company_website_locale_id').value"
          >
            <div class="modal-section-title mt-2 mb-2">
              {{ getWebsiteLocaleName(websiteLocale.get('company_website_locale_id').value) }}
            </div>

            <div class="form-group">
              <label>{{ 'CITIES.CITY_SEO_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>

            <div class="form-group">
              <label>{{ 'CITIES.CITY_SEO_FORM.DESCRIPTION' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="description"
                [attrs]="{ min_height: 200 }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'CITIES.CITY_SEO_FORM.SLUG' | translate }}</label>
              <input type="text" class="form-control" formControlName="slug" />
            </div>

            <div class="form-group">
              <label>{{ 'CITIES.CITY_SEO_FORM.META_TITLE' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_title" />
            </div>

            <div class="form-group">
              <label>{{ 'CITIES.CITY_SEO_FORM.META_DESCRIPTION' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_description" />
            </div>

            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [attr.id]="'active' + '-' + websiteLocale.get('company_website_locale_id').value"
                formControlName="active"
              />
              <label
                class="custom-control-label"
                [attr.for]="'active' + '-' + websiteLocale.get('company_website_locale_id').value"
              >
                {{ 'CITIES.CITY_SEO_FORM.ACTIVE' | translate }}
              </label>
            </div>

            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [attr.id]="'top' + '-' + websiteLocale.get('company_website_locale_id').value"
                formControlName="top"
              />
              <label
                class="custom-control-label"
                [attr.for]="'top' + '-' + websiteLocale.get('company_website_locale_id').value"
              >
                {{ 'CITIES.CITY_SEO_FORM.TOP' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="hotel-seo-form" [disabled]="form.invalid">
    {{ 'CITIES.CITY_SEO_FORM.SAVE' | translate }}
  </button>
</div>
